import React from 'react';
import { LoadingProps } from '../../types';

const Loading: React.FC<LoadingProps> = ({ size = 'md', text = 'Loading...', className = '' }) => {
  const sizeClasses = {
    sm: 'h-4 w-4',
    md: 'h-8 w-8',
    lg: 'h-12 w-12',
  };

  return (
    <div className={`flex flex-col items-center justify-center space-y-2 ${className}`}>
      <div className={`loading-spinner ${sizeClasses[size]}`} />
      {text && <p className='text-sm text-gray-600 animate-pulse'>{text}</p>}
    </div>
  );
};

export default Loading;
